import { Stack } from '@mui/material';

import {
  selectImpactCalculateVenueCo2ForProject,
  selectImpactCalculateVenueEnvForProject,
  selectImpactCalculateVenueEssForProject,
  selectImpactCalculateVenueForProject,
} from '@/domain/impact-calculate-venue/impact-calculate-venue.selectors';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { ScoreTag } from '@/ui/components/score/ScoreTag';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ColorsScore } from '@/ui/theme/colors-score';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

import { ProjectVenueCard } from './ProjectVenueCard';
import { ProjectVenueCardContentBox } from './ProjectVenueCardContentBox';

export function ProjectVenueCardDates({
  onClickOpenDates,
}: {
  onClickOpenDates: () => void;
}) {
  const project = useAppSelector(selectCurrentProjectVenue);
  const calculateVenueCo2 = useAppSelector(
    selectImpactCalculateVenueCo2ForProject(project?.id || -1),
  );
  const calculateVenueEnv = useAppSelector(
    selectImpactCalculateVenueEnvForProject(project?.id || -1),
  );
  const calculateVenueEss = useAppSelector(
    selectImpactCalculateVenueEssForProject(project?.id || -1),
  );
  const countVenue = useAppSelector(
    selectImpactCalculateVenueForProject(project?.id || -1),
  );
  return (
    <ProjectVenueCard title={translate('ProjectsVenue.manage-dates')}>
      <Stack sx={{ gap: 2, alignItems: 'center' }}>
        <ProjectVenueCardContentBox
          topLeftValue={countVenue?.count?.dates?.toString() || '0'}
          topLeftLabel={translate('ProjectsVenue.events')}
          bottomLeftValue={countVenue?.count?.participants?.toString() || '0'}
          bottomLeftLabel={translate('ProjectsVenue.participants')}
          scoreComponent={
            <Stack sx={{ flexDirection: 'row', gap: 2 }}>
              <ScoreTag
                value={calculateVenueCo2.dates.score}
                colors={ColorsScore.none}
                topic="co2"
                orientation="vertical"
              />
              <ScoreTag
                value={calculateVenueEnv.dates.scoreLetter}
                colors={getColorForScore(calculateVenueEnv.dates.scoreLetter)}
                topic="env"
                orientation="vertical"
              />
              <ScoreTag
                value={calculateVenueEss.dates.scoreLetter}
                colors={getColorForScore(calculateVenueEss.dates.scoreLetter)}
                topic="ess"
                orientation="vertical"
              />
            </Stack>
          }
        />
        <FSPrimaryButton onClick={onClickOpenDates}>
          {translate('Common.visit-text-button')}
        </FSPrimaryButton>
      </Stack>
    </ProjectVenueCard>
  );
}
